var _defs, _path, _path2, _path3, _rect, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDesign = function SvgDesign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Design_svg__be2ef9b4-9fb1-4edd-ad8e-549ed8431aa3{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Design_svg__beee1d2c-a1d9-4a2a-9596-e4f828091d43",
    "data-name": "Design"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Design_svg__be2ef9b4-9fb1-4edd-ad8e-549ed8431aa3",
    d: "M112.93 134.83H221v22.78h0-108.07a8.31 8.31 0 0 1-8.31-8.31v-6.16a8.31 8.31 0 0 1 8.31-8.31Z",
    transform: "rotate(-60 162.823 146.222)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Design_svg__be2ef9b4-9fb1-4edd-ad8e-549ed8431aa3",
    transform: "rotate(-60 195.618 89.42)",
    d: "M188.24 82.04H203V96.8h-14.76z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Design_svg__be2ef9b4-9fb1-4edd-ad8e-549ed8431aa3",
    d: "m199.31 83.03 6.67-11.57M134.51 172.49l19.72 11.39M129 182l-8.22-15.84-20.39-39.28L85.44 98l-25.87 14.93 53 83a9.17 9.17 0 0 0 12.52 3.35l2.35-1.35a9.09 9.09 0 0 0 3.19-3.09M72.87 132.8l23.32-13.47M61.63 111.35C48.9 105.7 45.19 99.72 44.3 95.13c-1.18-6 2.48-9.78 1.23-16.71s-6.62-12-11.1-15.15c2.18-.54 19.15-4.45 34 6.92 13.08 10 15 24.58 15.32 27.21M100.42 126.86V87.3a30 30 0 0 1 60 0v40.3M138.17 166.14h-17.36"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Design_svg__be2ef9b4-9fb1-4edd-ad8e-549ed8431aa3",
    x: 117.92,
    y: 79.92,
    width: 25,
    height: 10,
    rx: 5,
    transform: "rotate(-90 130.42 84.92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Design_svg__be2ef9b4-9fb1-4edd-ad8e-549ed8431aa3",
    d: "M100.42 112.08h30V97.42M130.42 57.3v15.12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Design_svg__be2ef9b4-9fb1-4edd-ad8e-549ed8431aa3",
    d: "M160.42 112.08h-30V97.42M130.42 57.3v15.12"
  }))));
};

export default SvgDesign;